module.exports = __webpack_public_path__ + "static/media/26UNRWA19.1097c72d.jpg";